import { render } from "./dataDownload.vue?vue&type=template&id=1069a4a1&scoped=true"
import script from "./dataDownload.vue?vue&type=script&lang=js"
export * from "./dataDownload.vue?vue&type=script&lang=js"

import "./dataDownload.vue?vue&type=style&index=0&id=1069a4a1&scoped=true&lang=css"

import exportComponent from "F:\\2021年交接\\前端嘉俊交接\\项目\\新重本紫腾重构\\zbzt-website-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1069a4a1"]])

export default __exports__